import { MessageOption } from "@/types/conversationTypes";

interface Props {
  option: MessageOption;
}

const ArticleOption = ({ option }: Props) => {
  const details = option.articleDetails;
  if (!details) return null;

  const { link, summary, language, translationLink } = details;
  const title = option.title || "Untitled article";
  const description = option.description || summary || "";

  return (
    <div className="p-4 border border-sky-100 rounded-xl bg-white shadow-sm text-xs flex gap-4">
      <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-sky-50 text-sky-600 shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
          <path d="M18 14h-8" />
          <path d="M15 18h-5" />
          <path d="M10 6h8v4h-8V6Z" />
        </svg>
      </div>
      <div className="flex-1 flex flex-col gap-1 min-w-0">
        <h3
          className="text-sm font-semibold text-gray-900 leading-tight truncate"
          title={title}
        >
          {title}
        </h3>
        {language && (
          <span className="text-[10px] text-sky-600 font-medium uppercase">
            {language}
          </span>
        )}
        {description && (
          <p
            className="text-[11px] text-gray-700 line-clamp-3"
            title={description}
          >
            {description}
          </p>
        )}
        <div className="flex items-center gap-3 mt-1">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-[11px] text-sky-600 hover:text-sky-700 font-medium underline decoration-sky-300 decoration-[1.5px] underline-offset-[3px]"
          >
            Read article
          </a>
          {translationLink && (
            <a
              href={translationLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-[11px] text-gray-500 hover:text-gray-600 font-medium underline decoration-gray-300 decoration-[1.5px] underline-offset-[3px]"
            >
              View translation
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleOption;
